import {score} from "./answer";
import {apiEnding} from "./api";

const correctAnswersFrame = document.querySelector('#ending .correct-answers');
const finalScoreFrame = document.querySelector('#ending .final-score');
const restartElement = document.querySelector('#ending h1');
const endingSound = new Audio('assets/audio/ending.mp3');

export async function ending() {
    let finalScore = score * scoreMultiplier
    switch (scoreRoundMode) {
        case 'round':
            finalScore = Math.round(finalScore)
            break;
        case 'floor':
            finalScore = Math.floor(finalScore)
            break;
        case 'ceil':
            finalScore = Math.ceil(finalScore)
            break;
    }

    correctAnswersFrame.textContent = score;
    finalScoreFrame.textContent = finalScore;

    endingSound.play();

    document.querySelector('header').fadeOut();
    await document.querySelector('#questions').fadeOut();
    document.querySelector('#ending').fadeIn('flex');

    apiEnding(finalScore);
}

let pressTimer;

function startPress() {
    pressTimer = setTimeout(() => {
        location.reload();
    }, 3000);
}

function cancelPress() {
    clearTimeout(pressTimer);
}

restartElement.addEventListener('mousedown', startPress);
restartElement.addEventListener('mouseup', cancelPress);
restartElement.addEventListener('touchstart', startPress);
restartElement.addEventListener('touchend', cancelPress);